import { useSyncExternalStore } from 'react';

const PHONE = '(max-width: 767px)';

function subscribe(query: string) {
  return (onChange: () => void) => {
    const mq = window.matchMedia(query);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  };
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(subscribe(query), () => window.matchMedia(query).matches, () => false);
}

/** The phone cut of the shell (planning-app.md §4.1): below 768 CSS px, the tab bar replaces the sidebar. */
export function useIsPhone(): boolean {
  return useMediaQuery(PHONE);
}
